import React from 'react'
import { Skeleton } from 'antd'

import { QueuedPrescription } from './QueuedPrescription'
import { Header3 } from '../../../Styles'

export const QueuedUpPrescriptions = ({
    prescriptions = [],
    isAssignedProvider,
    selectPrescription,
    removePrescription,
    onTemplateChange,
    loading = false
}) => {
    return (
        <>
            <Header3>Queued Up Prescriptions</Header3>
            <Skeleton loading={loading} active paragraph={{ rows: 3 }}>
                {
                    !prescriptions.length && (
                        <div>
                            <p>No prescriptions queued</p>
                        </div>
                    )
                }
                {
                    prescriptions.map((prescription) => {
                        return (
                            <QueuedPrescription
                                key={prescription._id}
                                background='rgba(123, 173, 126, .15)'
                                prescription={prescription}
                                isAssignedProvider={isAssignedProvider}
                                handleSelectPrescription={() => selectPrescription(prescription._id)}
                                handleRemovePrescription={() => removePrescription(prescription._id)}
                                onTemplateChange={onTemplateChange}
                            />
                        )
                    })
                }
            </Skeleton>
        </>
    )
}
